const theLookService = {

    performSizeChange(currentTarget) {
        const $currentTarget  = $(currentTarget);
        const dataset         = currentTarget.dataset;
        const $productTile    = $currentTarget.closest('.js-the-look__product');
        const $tileBody       = $productTile.find('.tile__body');
        const $tilePrice      = $productTile.find('.tile__price');
        const $tileSoldOutMsg = $productTile.find('.the-look__soldout');
        const price           = dataset.discountedPrice === '' ? dataset.price : dataset.discountedPrice;

        // remove previous selection
        $currentTarget
                .parent()
                .find('.size-selector__size--active')
                .removeClass('size-selector__size--active');
        // add new selection
        $currentTarget.addClass('size-selector__size--active');
        // toggle between notifyMe button and add2cart/outOfStock button
        if (dataset.notifyMe === 'true' && dataset.outOfStock === 'true') {
            // copy needed data to notifyMe button and show it
            $productTile
                    .find('.js-the-look__notifyme')
                    .attr('data-code', dataset.code)
                    .removeClass('d-none')
                    .end()
                    .find('.js-the-look__add-to-cart, .js-the-look__out-of-stock, .js-the-look__sold-out')
                    .addClass('d-none');
        } else if (dataset.outOfStock === 'true' && dataset.notifyMe === 'false') {
            // toggle between outOfStock button and add2cart/notifyMe button
            $productTile
                    .find('.js-the-look__out-of-stock')
                    .removeClass('d-none')
                    .end()
                    .find('.js-the-look__add-to-cart, .js-the-look__notifyme, .js-the-look__sold-out')
                    .addClass('d-none');
        } else {
            // copy needed data to add2cart button and show it
            $productTile
                    .find('.js-the-look__add-to-cart')
                    .attr('data-code', dataset.code)
                    .removeClass('d-none')
                    .end()
                    .find('.js-the-look__notifyme, .js-the-look__out-of-stock, .js-the-look__sold-out')
                    .addClass('d-none');
        }

        // update price and product information
        if (dataset.oldPrice === '' || dataset.oldPrice === price) {
            $tilePrice.replaceWith(`<span class="tile__price">
                                        <span>${price}</span>
                                    </span>`);
        } else {
            $tilePrice.replaceWith(`<span class="tile__price">
                                        <span class="tile__price--discounted">${price}</span>
                                        <s class="tile__price--strike">${dataset.oldPrice}</s>
                                    </span>`);
        }
        // remove error message
        this.clearLocalErrorMessages(currentTarget).call(null);
    },

    /**
     * Render for a given product an error message
     */
    renderLocalErrorMessages(currentTarget) {
        const $errorContainer = $(currentTarget).closest('.js-the-look__product').find('.js-the-look__add-cart-errors');

        return (errors) => {
            $.each(errors, (index, element) => {
                $errorContainer.append(`<div class="add-cart-error">${element}</div>`);
            });
        }
    },
    /**
     * Remove the error message of a given product
     */
    clearLocalErrorMessages(currentTarget) {
        const $errorContainer = $(currentTarget).closest('.js-the-look__product').find('.js-the-look__add-cart-errors');

        return () => {
            $errorContainer.empty();
        }
    },

}

export default theLookService;
